import script from "./edit-delta.vue?vue&type=script&lang=js"
export * from "./edit-delta.vue?vue&type=script&lang=js"

import "./edit-delta.vue?vue&type=style&index=0&id=4bff79c6&lang=scss"

const __exports__ = script;

export default __exports__